import React, { useEffect, useState, useCallback } from "react";

import { useParams } from "react-router";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, isBefore, parse, isValid, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Button,
  SimpleGrid,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../../components/LoadingSpinner";
import CustomDropzone from "../../../../components/CustomDropzone";
import DesligarModal from "./Desligar";
import FileInformation from "../../../../components/FileInformation";

import PessoaEmCumprimentoSAService from "../../../../../main/services/PessoaEmCumprimentoSAService";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { Permission, servicos } from "../../../../../helpers/Funcionalidades";

const VisualizarEditarPessoaEmCumprimentoModal = ({
  isOpen,
  onOpen,
  onClose,
  id,
  isEdicao,
  editarPenaServ,
  setEditarPenaServ,
  roleKeycloack,
  user,
  idPJ,
}) => {
  const { id: idSA } = useParams();

  const {
    isOpen: isOpenDesligar,
    onOpen: onOpenDesligar,
    onClose: onCloseDesligar,
  } = useDisclosure();

  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [isVisualizacao, setIsVisualizacao] = useState(isEdicao ? false : true);
  const [loading, setLoading] = useState(true);
  const [anexoEditadoOficio, setAnexoEditadoOficio] = useState(false);
  const [initialValues, setInitialValues] = useState({
    nome: "",
    atividadesDesenvolvidas: "",
    dataInicioAtividades: "",
    dataTerminoAtividades: "",
    anexo: null,
    anexoOficio: null,
    dataDocumento: "",
  });

  const handleGetPessoa = useCallback(() => {
    PessoaEmCumprimentoSAService.getPessoaEmCumprimento(id, idSA)
      .then((res) => {
        const {
          anexoOficio,
          servicoAcolhimento,
          dataInicioAtividades,
          dataTerminoAtividades,
          dataDocumento,
          ...resto
        } = res.data;

        if (!anexoOficio) {
          setAnexoEditadoOficio(true);
        }

        setInitialValues({
          anexoOficio,
          anexo: null,
          dataInicioAtividades: dataInicioAtividades
            ? format(new Date(dataInicioAtividades), "dd/MM/yyyy")
            : "",
          dataTerminoAtividades: dataTerminoAtividades
            ? format(new Date(dataTerminoAtividades), "dd/MM/yyyy")
            : "",
          dataDocumento: dataDocumento
            ? format(new Date(dataDocumento), "dd/MM/yyyy")
            : "",
          ...resto,
        });

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          onClose();
        });
      });
  }, [id, idSA, setAnexoEditadoOficio, setInitialValues, setLoading, onClose]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    handleGetPessoa();
  }, [handleGetPessoa]);

  useEffect(() => {
    if (isVisualizacao) {
      handleGetPessoa();
    }
  }, [isVisualizacao, handleGetPessoa]);

  const handlePessoaDesligada = () => {
    onCloseDesligar();
    onClose();
  };

  const backAlert = () => {
    if (isVisualizacao) {
      onClose();
    } else {
      if (editarPenaServ) {
        Swal.fire({
          title: "Tem certeza que deseja cancelar?",
          text: "As informações serão perdidas.",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#169499",
          cancelButtonColor: "#169499",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
            setEditarPenaServ(false);
          }
        });
      } else {
        onClose();
      }
    }
  };

  const schema = Yup.object().shape({
    nome: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    atividadesDesenvolvidas: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    dataInicioAtividades: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    dataTerminoAtividades: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .when("dataInicioAtividades", (dataInicioAtividades, schema) => {
        return schema.test(
          "dataTerminoAtividades",
          "Data de término não pode ser anterior ao início!",
          (value) => {
            if (value === null) {
              return false;
            } else {
              return !isBefore(
                parse(value, "dd/MM/yyyy", new Date()),
                parse(dataInicioAtividades, "dd/MM/yyyy", new Date()),
              );
            }
          },
        );
      })
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    dataDocumento: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test(
        "dataDocumentoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (value === null) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        },
      )
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    anexo: Yup.mixed()
      .test("anexoRequired", "Este campo é obrigatório!", (value) => {
        if (anexoEditadoOficio) {
          return value !== null;
        } else {
          return true;
        }
      })
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        anexo,
        anexoOficio,
        dataInicioAtividades,
        dataTerminoAtividades,
        dataDocumento,
        nome,
        atividadesDesenvolvidas,
        ...resto
      } = values;

      const valuesToSend = {
        anexoOficio: anexo,
        anexoEditadoOficio,
        dataInicioAtividades: dataInicioAtividades
          ? parse(dataInicioAtividades, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        dataTerminoAtividades: dataTerminoAtividades
          ? parse(dataTerminoAtividades, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        dataDocumento: dataDocumento
          ? parse(dataDocumento, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        nome: nome ? nome.trim() : "",
        atividadesDesenvolvidas: atividadesDesenvolvidas
          ? atividadesDesenvolvidas.trim()
          : "",
        ...resto,
      };

      PessoaEmCumprimentoSAService.atualizarPessoaEmCumprimentoSA(
        id,
        idSA,
        valuesToSend,
      )
        .then((res) => {
          onClose();
          Swal.fire({
            title: "Sucesso!",
            text: "Registro atualizado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            setEditarPenaServ(false);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (
                  error.response.data.field === "pessoa" ||
                  error.response.data.field === "errors"
                ) {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message
                      ? JSON.parse(error.response.data.message).pessoa
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {
                    onClose();
                  });
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={backAlert} size="6xl">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#95BCBF"
        >
          {isVisualizacao
            ? "VISUALIZAR PESSOA EM CUMPRIMENTO DE PENA"
            : "EDITAR PESSOA EM CUMPRIMENTO DE PENA"}
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          {!loading ? (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form>
                  {setEditarPenaServ(
                    hasFormChanged(initialValues, props.values),
                  )}
                  <Flex flexDir="column">
                    <Grid
                      mt="20px"
                      templateColumns={{
                        base: "repeat(1, 1fr)",
                        lg: "repeat(8, 1fr)",
                      }}
                      gap="20px"
                      rowGap="15px"
                    >
                      <GridItem colSpan={4}>
                        <Field name="nome">
                          {({ field, form }) => (
                            <FormControl
                              isInvalid={form.errors.nome && form.touched.nome}
                              id="nome"
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="nome"
                              >
                                Nome*
                              </FormLabel>
                              <Input
                                {...field}
                                h="42px"
                                name="nome"
                                id="nome"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                placeholder="Informe o Nome"
                                isDisabled={isVisualizacao}
                              />
                              <FormErrorMessage>
                                {form.errors.nome}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </GridItem>
                      <GridItem colSpan={4}>
                        <Field name="atividadesDesenvolvidas">
                          {({ field, form }) => (
                            <FormControl
                              isInvalid={
                                form.errors.atividadesDesenvolvidas &&
                                form.touched.atividadesDesenvolvidas
                              }
                              id="atividadesDesenvolvidas"
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="atividadesDesenvolvidas"
                              >
                                Atividades Desenvolvidas*
                              </FormLabel>
                              <Input
                                {...field}
                                h="42px"
                                name="atividadesDesenvolvidas"
                                id="atividadesDesenvolvidas"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                placeholder="Informe as Atividades"
                                isDisabled={isVisualizacao}
                              />
                              <FormErrorMessage>
                                {form.errors.atividadesDesenvolvidas}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </GridItem>
                      <GridItem colSpan={2}>
                        <CustomDatepickerWField
                          fieldName="dataInicioAtividades"
                          label="Início das Atividades no Serviço de Acolhimento*"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisualizacao}
                        />
                      </GridItem>
                      <GridItem colSpan={2} />
                      <GridItem colSpan={2}>
                        <CustomDatepickerWField
                          fieldName="dataTerminoAtividades"
                          label="Término das Atividades no Serviço de Acolhimento*"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisualizacao}
                        />
                      </GridItem>
                      <GridItem colSpan={2} />
                      <GridItem colSpan={2}>
                        {anexoEditadoOficio ? (
                          <CustomDropzone
                            title="Anexar Ofício e/ou Decisão Judicial*"
                            fieldName="anexo"
                            whiteSpace={true}
                            formProps={props}
                            setAnexoNaoEditado={() => {
                              setAnexoEditadoOficio(false);
                            }}
                          />
                        ) : (
                          initialValues.anexoOficio && (
                            <FileInformation
                              label="Anexar Ofício e/ou Decisão Judicial*"
                              name={initialValues.anexoOficio.nomeArquivo}
                              path={initialValues.anexoOficio.pathAnexo
                                .toString()
                                .split("/")
                                .pop()}
                              setAnexoEditado={() => {
                                setAnexoEditadoOficio(true);
                              }}
                              isVisualizacao={isVisualizacao}
                              whiteSpace={true}
                            />
                          )
                        )}
                      </GridItem>
                      <GridItem colSpan={2} />
                      <GridItem colSpan={2}>
                        <CustomDatepickerWField
                          fieldName="dataDocumento"
                          label="Data do Documento*"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisualizacao}
                        />
                      </GridItem>
                    </Grid>

                    <SimpleGrid
                      alignSelf="center"
                      mt="20px"
                      columns={{ base: 1, lg: isVisualizacao ? 3 : 2 }}
                      spacing="15px"
                      w={{ base: "100%", lg: isVisualizacao ? "50%" : "40%" }}
                    >
                      <Button
                        id="button-voltar-modal"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        _hover={{ bg: "#169499" }}
                        onClick={backAlert}
                      >
                        Voltar
                      </Button>
                      {!isVisualizacao && (
                        <Button
                          id="button-salvar-modal"
                          type="submit"
                          translate="no"
                          color="#FFF"
                          backgroundColor="#169499"
                          fontWeight={700}
                          fontSize="15px"
                          lineHeight="21.6px"
                          _hover={{ bg: "#169499" }}
                          isLoading={props.isSubmitting}
                        >
                          Salvar
                        </Button>
                      )}
                      {isVisualizacao && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={servicos.cumprimentoEditar}
                          id={idPJ}
                          user={user}
                        >
                          <Button
                            id="button-editar-modal"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            onClick={() => {
                              setIsVisualizacao(false);
                            }}
                          >
                            Editar
                          </Button>
                        </Permission>
                      )}
                      {isVisualizacao && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={servicos.cumprimentoDesligar}
                          id={idPJ}
                          user={user}
                        >
                          <Button
                            id="button-desligar-modal"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            onClick={onOpenDesligar}
                          >
                            Desligar
                          </Button>
                        </Permission>
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          ) : (
            <Flex w="100%" mt="25%" justifyContent="center">
              <LoadingSpinner />
            </Flex>
          )}
          {isOpenDesligar && (
            <DesligarModal
              isOpen={isOpenDesligar}
              onOpen={onOpenDesligar}
              onClose={onCloseDesligar}
              id={id}
              idSA={idSA}
              inicioAtividade={initialValues.dataInicioAtividades}
              handlePessoaDesligada={handlePessoaDesligada}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VisualizarEditarPessoaEmCumprimentoModal;
